var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-button",on:{"click":function($event){return _vm.changeRoute(_vm.path)}}},[(_vm.icon)?_c('div',{class:['home-button__icon ' + _vm.icon + '-icon']}):_vm._e(),(_vm.title)?_c('v-clamp',{staticClass:"home-button__text",attrs:{"autoresize":"","max-lines":2}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }